import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class GroupStateService {
  private shownavigatetomenu: boolean = true;

  constructor() {}

  getshownavigatetomenu() {
    return this.shownavigatetomenu;
  }

  setshownavigatetomenu(shownavigatetomenu: boolean) {
    this.shownavigatetomenu = shownavigatetomenu;
  }
}